import React, { useState } from "react";
import { Card, ListGroupItem, ListGroup, Button, Row } from "react-bootstrap";
import ipfs from "./ipfs";

export default function Upload() {
  const [loadingFile, setLoadingFile] = useState(false);
  const [uploadingIPFS, setUploadingIPFS] = useState(false);
  const [ipfsHash, setIpfsHash] = useState(null);
  const [myFile, setMyFile] = useState(null);
  const [buffer, setBuffer] = useState(null);

  const readFile = file => {
    setMyFile(file);
    setLoadingFile(true);

    var reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = () => {
      const _buffer = Buffer(reader.result);
      setBuffer(_buffer);
      setLoadingFile(false);
    };
  };

  const addToIpfs = () => {
    setUploadingIPFS(true);

    ipfs.files.add(buffer, (error, result) => {
      if (error) {
        console.error(error);
        setUploadingIPFS(false);
        return;
      }
      setIpfsHash(result[0].hash);
      setUploadingIPFS(false);
    });
  };

  return (
    <Row className="justify-content-center">
      <div style={{ width: "70%" }}>
        <Card className="mt-5 mb-3" style={{ width: "70%" }}>
          <Card.Body style={{ padding: "60px" }}>
            <Card.Title className="read-title">File Upload</Card.Title>
            {loadingFile ? (
              <h3>Loading File...</h3>
            ) : myFile ? (
              <label htmlFor="file">
                <strong>File: </strong>
                {myFile.name}
              </label>
            ) : (
              <>
                <input
                  id="file"
                  type="file"
                  name="file"
                  className="inputfile"
                  onChange={e => readFile(e.target.files[0])}
                />
                <label htmlFor="file">Upload a File</label>
              </>
            )}
            {uploadingIPFS && <h5>Storing file in IPFS...</h5>}
            {ipfsHash && (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`https://ipfs.io/ipfs/${ipfsHash}`}
              >
                Check file on IPFS
              </a>
            )}
          </Card.Body>
          <ListGroup className="list-group-flush">
            <ListGroupItem>
              <strong>IPFS Hash: </strong>
              {ipfsHash && (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://ipfs.io/ipfs/${ipfsHash}`}
                >
                  {ipfsHash}
                </a>
              )}
            </ListGroupItem>
          </ListGroup>
          <Card.Footer className="text-center">
            <Button onClick={addToIpfs}>Add to IPFS</Button>
          </Card.Footer>
        </Card>
      </div>
    </Row>
  );
}
